import type { ReceiptTemplate } from '../schema';

export const swiggyTemplate: ReceiptTemplate = {
  id: 'swiggy',
  name: 'Swiggy Order Receipt',
  brand: 'Swiggy',
  description: 'Swiggy food delivery receipt template',
  settings: {
    width: 280,
    font: 'Arial',
    fontSize: 12,
    paperStyle: 'plain',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '₹',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'swiggy-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/swiggy.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'swiggy-title',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ORDER RECEIPT',
        fontSize: 16,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'swiggy-order-info',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 40,
        lines: [
          { id: 'swiggy-order', label: 'Order ID', value: '#847291847', isBold: false, isLarge: false },
          { id: 'swiggy-date', label: 'Date', value: '04 Jan 2026', isBold: false, isLarge: false },
          { id: 'swiggy-time', label: 'Time', value: '7:30 PM', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'swiggy-restaurant',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'FROM: Biryani Blues\nKhan Market, New Delhi',
        fontSize: 11,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'swiggy-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'swiggy-item-1', name: 'Hyderabadi Chicken Biryani', quantity: '1', price: '349.00'},
          { id: 'swiggy-item-2', name: 'Paneer Tikka', quantity: '1', price: '249.00'},
          { id: 'swiggy-item-3', name: 'Gulab Jamun (2 pcs)', quantity: '1', price: '79.00'},
          { id: 'swiggy-item-4', name: 'Raita', quantity: '1', price: '49.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'swiggy-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        lines: [
          { id: 'swiggy-subtotal', label: 'Item Total', value: '726.00', isBold: false, isLarge: false },
          { id: 'swiggy-delivery', label: 'Delivery Fee', value: '40.00', isBold: false, isLarge: false },
          { id: 'swiggy-platform', label: 'Platform Fee', value: '5.00', isBold: false, isLarge: false },
          { id: 'swiggy-gst', label: 'GST (5%)', value: '38.55', isBold: false, isLarge: false },
          { id: 'swiggy-discount', label: 'Discount', value: '-100.00', isBold: false, isLarge: false },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'swiggy-total',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        lines: [
          { id: 'swiggy-grand', label: 'GRAND TOTAL', value: '709.55', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 25,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'swiggy-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'PAID VIA: Swiggy Money\nTransaction ID: SWG847291847291',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'swiggy-delivery-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'DELIVERED TO:\n123 Green Park Extension\nNew Delhi - 110016',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'swiggy-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for ordering!\nFor support: support@swiggy.in',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
